import { ArcElement, Chart as ChartJS, Legend, Tooltip } from 'chart.js'
import { Doughnut } from 'react-chartjs-2'
import {
	Card,
	CardContent,
	CardHeader,
	CardTitle,
} from '@/modules/shared/components/ui/card'
import { useChartSalesByClientReport } from './useChartSalesByClientReport'

ChartJS.register(ArcElement, Tooltip, Legend)

export function ChartSalesByClientReport() {
	const { chartData } = useChartSalesByClientReport()

	const sortedData = chartData?.datasets?.[0]?.data
		? [...chartData.datasets[0].data]
			.map((value, index) => ({ value, label: chartData.labels[index], color: chartData.datasets[0].backgroundColor[index] }))
			.sort((a, b) => b.value - a.value)
			.slice(0, 25)
		: []

	const limitedChartData = {
		labels: sortedData.map(item => item.label),
		datasets: [
			{
				...chartData?.datasets?.[0],
				data: sortedData.map(item => item.value),
				backgroundColor: sortedData.map(item => item.color),
			},
		],
	}

	return (
		<Card>
			<CardHeader>
				<CardTitle className="text-lg">Gráfico Cidade x Valor</CardTitle>
			</CardHeader>
			<CardContent className="max-w-[320px] m-auto">
				<Doughnut
					data={limitedChartData}
					options={{
						plugins: {
							datalabels: {
								display: false,
							},
						},
					}}
				/>
			</CardContent>
		</Card>
	)
}